/**
 * Toast condiviso per errori/avvisi carrello (limite prodotti, gift card, ecc.).
 * Stesso stile della notifica gift-card (showNotification).
 */
(function () {
  function getTranslations() {
    const el = document.querySelector('cart-error');
    if (!el || !el.dataset) {
      return {
        goToCart: 'Vai al carrello',
        close: 'Chiudi',
        cartHref: '/cart'
      };
    }
    return {
      goToCart: el.dataset.cartToastGoto || 'Vai al carrello',
      close: el.dataset.cartToastClose || 'Chiudi',
      cartHref: el.dataset.cartToastHref || '/cart'
    };
  }

  function ensureStyles() {
    if (document.querySelector('#cart-toast-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-toast-styles';
    style.textContent = `
      @keyframes cartToastSlideDown {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Mostra un toast tipo gift-card (stesso UI).
   * @param {string} message - Testo del messaggio
   * @param {'info'|'warning'|'error'} type - Tipo (error -> alert-danger)
   * @param {boolean} showCartButton - Mostra "Vai al carrello" + "Chiudi"
   * @param {boolean} persistent - Se true, timeout più lungo
   */
  function showCartToast(message, type = 'error', showCartButton = true, persistent = false) {
    ensureStyles();
    document.querySelectorAll('.cart-toast').forEach((n) => n.remove());

    const t = getTranslations();
    const alertType = type === 'error' ? 'danger' : type;
    const notification = document.createElement('div');
    notification.className = `cart-toast alert alert-${alertType} position-fixed start-50 translate-middle-x shadow-lg border-2`;
    notification.setAttribute('role', 'alert');
    notification.setAttribute('aria-live', 'assertive');
    notification.style.cssText =
      'z-index: 99999; min-width: 350px; max-width: 500px; top: 100px; animation: cartToastSlideDown 0.3s ease-out;';

    let buttonsHtml = '';
    if (showCartButton) {
      buttonsHtml = `
        <div class="mt-3 d-flex gap-2">
          <a href="${t.cartHref}" class="btn btn-sm btn-${alertType}">${t.goToCart}</a>
          <button type="button" class="btn btn-sm btn-outline-secondary btn-close-cart-toast">${t.close}</button>
        </div>
      `;
    }

    notification.innerHTML = `
      <div class="d-flex justify-content-between align-items-start">
        <div class="flex-grow-1">
          <div class="fw-bold mb-1">${message}</div>
          ${buttonsHtml}
        </div>
        <button type="button" class="btn-close ms-3" aria-label="Close"></button>
      </div>
    `;

    document.body.appendChild(notification);

    const closeBtn = notification.querySelector('.btn-close');
    const closeCustom = notification.querySelector('.btn-close-cart-toast');
    function remove() {
      if (notification.parentNode) {
        notification.style.animation = 'cartToastSlideDown 0.3s ease-out reverse';
        setTimeout(() => notification.remove(), 300);
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', remove);
    if (closeCustom) closeCustom.addEventListener('click', remove);

    const timeout = type === 'error' ? 10000 : persistent ? 15000 : 5000;
    setTimeout(remove, timeout);
  }

  window.showCartToast = showCartToast;
})();
